/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { User } from "@auth0/auth0-spa-js";

/**
 * The auth state which, when combined with the auth methods, make up the return object of the `useAuth0` hook.
 */
export type AuthState<TUser extends User = User> = {
  error?: Error;
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: TUser;
};

/**
 * The initial auth state.
 */
export const initialAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
};
